import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import type {
    PolygonTags,
    GetSitePolygons,
    AddPolygonTagInput,
    AddPolygonTagResult,
    DeletePolygonTagInput,
    DeletePolygonTagResult,
    RenamePolygonInput,
    RenamePolygonResult,
} from 'src/shared/types/graph';
import {
    getSitesWithTagsQuery,
    addPolygonLevelTagMutation,
    deletePolygonLevelTagMutation,
    renamePolygonMutation,
} from './queries/polygonManagementQuery';

type GetSitesWithTagsParams = {
    projectId: string;
};

const siteTagsGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        getSitesWithTags: builder.query<PolygonTags[], GetSitesWithTagsParams>({
            query: params => ({
                body: getSitesWithTagsQuery,
                variables: params,
            }),
            transformResponse: (response: GetSitePolygons) => response.admin.sites,
            providesTags: ['site'],
        }),
        addPolygonLevelTag: builder.mutation<boolean, AddPolygonTagInput>({
            query: input => ({
                body: addPolygonLevelTagMutation,
                variables: { input },
            }),
            transformResponse: (response: AddPolygonTagResult) => response.admin.addAssetTag,
            invalidatesTags: ['site'],
        }),
        deletePolygonLevelTag: builder.mutation<boolean, DeletePolygonTagInput>({
            query: input => ({
                body: deletePolygonLevelTagMutation,
                variables: { input },
            }),
            transformResponse: (response: DeletePolygonTagResult) => response.admin.deleteAssetTag,
            invalidatesTags: ['site'],
        }),
        renamePolygon: builder.mutation<boolean, RenamePolygonInput>({
            query: input => ({
                body: renamePolygonMutation,
                variables: { input },
            }),
            transformResponse: (response: RenamePolygonResult) => response.admin.renameAsset,
            invalidatesTags: (_result, _error, input) => ['site', { type: 'project-sites', id: input.projectId }],
        }),
    }),
});

export const { useGetSitesWithTagsQuery, useAddPolygonLevelTagMutation, useDeletePolygonLevelTagMutation, useRenamePolygonMutation } =
    siteTagsGraphSlice;
